import pdfMake from 'pdfmake';
import axios from 'axios';

export const generatePDFProyeccion = (props, { table, formatter, toFixed, logo, footer, apiMethods }) => {
    var auxProps = props;

    // USAR DIRECTAMENTE LA PROYECCIÓN COMPLETA
    // ============================================
    let proyeccionOriginal = props.proyeccion || [];

    if (proyeccionOriginal.length === 0) {
        alert('No hay proyección disponible para generar el PDF');
        return;
    }

    // ============================================
    // CREAR COPIA Y AGREGAR CUOTA 0 AL INICIO
    // ============================================
    let proyeccionCompleta = JSON.parse(JSON.stringify(proyeccionOriginal));

    // Saldo inicial = monto total del préstamo (vlrInicial)
    const saldoInicial = parseFloat(String(props.vlrInicial).replace(/,/g, '')) || 0;
    const saldoInicialUVR = parseFloat(String(props.vlrInicialUVR).replace(/,/g, '')) || 0;

    // Verificar si ya existe cuota 0
    const indiceCuotaCero = proyeccionCompleta.findIndex(p => p.noCuota === 0);

    if (indiceCuotaCero !== -1) {
        // Si existe cuota 0, es que el backend numeró mal (0-11 en vez de 1-12)
        // Renumerar TODAS las cuotas sumando +1
        proyeccionCompleta.forEach((periodo) => {
            periodo.noCuota = periodo.noCuota + 1;
        });
    }

    // Ahora crear la cuota 0 correcta (todo en cero excepto el saldo)
    const cuotaCero = {
        noCuota: 0,
        capital: saldoInicial,
        capitalUVR: saldoInicialUVR,
        interes: 0,
        interesUVR: 0,
        vlrCuota: 0,
        vlrCuotaUVR: 0,
        segVida: 0,
        segTodoRiesgo: 0,
        liquidado: false,
        presentaPagos: false,
    };

    // Agregar la cuota 0 al inicio
    proyeccionCompleta.unshift(cuotaCero);

    // ============================================
    // VERIFICO Y AGREGO CUOTAS FALTANTES
    // ============================================
    const ultimaCuota = proyeccionCompleta[proyeccionCompleta.length - 1].noCuota;
    const cuotasEsperadas = parseInt(auxProps.plazo);

    if (ultimaCuota < cuotasEsperadas) {
        const cuotasFaltantes = cuotasEsperadas - ultimaCuota;

        // Calculo el saldo restante después de la última cuota
        const ultimaCuotaReal = proyeccionCompleta[proyeccionCompleta.length - 1];
        const indicePenultima = proyeccionCompleta.length - 1;

        // Saldo después de la penúltima cuota
        let saldoRestante, saldoRestanteUVR;

        if (props.moneda === "uvr") {
            const saldoStr = calcularSaldoProyectadoUVR(indicePenultima);
            saldoRestanteUVR = parseFloat(String(saldoStr).replace(/,/g, '')) || 0;
            saldoRestante = 0;
        } else {
            saldoRestante = calcularSaldoProyectadoPesos(indicePenultima);
            saldoRestanteUVR = 0;
        }

        // Agrego las cuotas faltantes
        for (let i = 1; i <= cuotasFaltantes; i++) {
            // Para la última cuota, ajusto para que el saldo llegue a 0
            const esUltimaCuota = (ultimaCuota + i) === cuotasEsperadas;

            let abono, abonoUVR, interes, interesUVR;

            if (esUltimaCuota) {
                // Última cuota: el abono debe ser igual al saldo restante
                abono = saldoRestante;
                abonoUVR = saldoRestanteUVR;

                // Calcular interés aproximado
                const tasaMensual = parseFloat(props.interes) / 12 / 100;

                if (props.moneda === "uvr") {
                    interesUVR = saldoRestanteUVR * tasaMensual;
                    interes = 0;
                } else {
                    interes = saldoRestante * tasaMensual;
                    interesUVR = 0;
                }
            } else {
                // Cuotas intermedias: usar valores de la última cuota real
                interes = ultimaCuotaReal.interes || 0;
                interesUVR = ultimaCuotaReal.interesUVR || 0;
                abono = (ultimaCuotaReal.vlrCuota || 0) - interes;
                abonoUVR = (ultimaCuotaReal.vlrCuotaUVR || 0) - interesUVR;
            }

            const nuevaCuota = {
                noCuota: ultimaCuota + i,
                capital: abono,
                capitalUVR: abonoUVR,
                interes: interes,
                interesUVR: interesUVR,
                vlrCuota: abono + interes,
                vlrCuotaUVR: abonoUVR + interesUVR,
                segVida: ultimaCuotaReal.segVida || 0,
                segTodoRiesgo: ultimaCuotaReal.segTodoRiesgo || 0,
            };

            proyeccionCompleta.push(nuevaCuota);

            // Actualizo saldo restante para siguientes iteraciones
            saldoRestante -= abono;
            saldoRestanteUVR -= abonoUVR;
        }
    }

    // Arrays para almacenar los datos de las tablas
    var datos_centrales = [];
    var altura_cuota = [];

    // ============================================
    // FUNCIONES AUXILIARES
    // ============================================

    function calcularSaldoProyectadoPesos(indexPeriodo) {
        const periodoActual = proyeccionCompleta[indexPeriodo];

        // Para cuota 0, mostrar saldo inicial
        if (periodoActual.noCuota === 0) {
            return parseFloat(String(props.vlrInicial).replace(/,/g, '')) || 0;
        }

        // Para las demás cuotas: saldo anterior - abono actual
        const saldoAnterior = calcularSaldoProyectadoPesos(indexPeriodo - 1);
        const abono = calcularAbonoPesos(indexPeriodo);
        return saldoAnterior - abono;
    }

    function calcularSaldoProyectadoUVR(indexPeriodo) {
        const periodoActual = proyeccionCompleta[indexPeriodo];

        // Para cuota 0, mostrar saldo inicial
        if (periodoActual.noCuota === 0) {
            const saldo = parseFloat(String(props.vlrInicialUVR).replace(/,/g, '')) || 0;
            return saldo.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }

        // Para las demás cuotas: saldo anterior - abono actual
        const saldoAnteriorStr = calcularSaldoProyectadoUVR(indexPeriodo - 1);
        const saldoAnterior = parseFloat(String(saldoAnteriorStr).replace(/,/g, '')) || 0;
        const abono = calcularAbonoUVR(indexPeriodo);
        const nuevoSaldo = saldoAnterior - abono;

        return nuevoSaldo.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    // Limpiar y parsear valores numéricos que pueden tener comas
    function parseValue(value) {
        if (value == null) return 0;
        // Si es string, quitar comas y parsear
        if (typeof value === 'string') {
            return parseFloat(value.replace(/,/g, '')) || 0;
        }
        return parseFloat(value) || 0;
    }

    // Formatear números
    function formatNumber(num) {
        if (num == null || isNaN(num)) return "0";
        return num.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }

    // Calcular abono a capital (diferencia entre saldo anterior y saldo actual)
    function calcularAbonoPesos(indexPeriodo) {
        const periodoActual = proyeccionCompleta[indexPeriodo];

        // Para cuota 0, el abono es 0
        if (periodoActual.noCuota === 0) {
            return 0;
        }

        // Abono = Cuota - Intereses
        const cuota = parseFloat(String(periodoActual.vlrCuota).replace(/,/g, '')) || 0;
        const interes = parseFloat(String(periodoActual.interes).replace(/,/g, '')) || 0;
        return cuota - interes;
    }

    // Calcular abono en UVR
    function calcularAbonoUVR(indexPeriodo) {
        const periodoActual = proyeccionCompleta[indexPeriodo];

        // Para cuota 0, el abono es 0
        if (periodoActual.noCuota === 0) {
            return 0;
        }

        // Abono = Cuota - Intereses
        const cuota = parseFloat(String(periodoActual.vlrCuotaUVR).replace(/,/g, '')) || 0;
        const interes = parseFloat(String(periodoActual.interesUVR).replace(/,/g, '')) || 0;
        return cuota - interes;
    }

    // ============================================
    // ITERAR SOBRE TODA LA PROYECCIÓN
    // ============================================
    let valorUnidadCalculado = 0;

    // Convertimos a números limpios para la división
    const montoPesos = parseFloat(String(props.vlrInicial).replace(/,/g, '')) || 0;
    const montoUVR = parseFloat(String(props.vlrInicialUVR).replace(/,/g, '')) || 0;

    if (montoUVR > 0) {
        valorUnidadCalculado = montoPesos / montoUVR;
    } else {
        valorUnidadCalculado = 395; // Fallback por seguridad si falla la división
    }

    // ============================================
    // ITERAR SOBRE TODA LA PROYECCIÓN
    // ============================================

    // Variable para arrastrar el saldo real
    let saldoAcumulado = 0;

    // Función de limpieza auxiliar
    const limpiar = (val) => {
        if (!val) return 0;
        if (typeof val === 'number') return val;
        // Quita puntos de miles y cambia coma decimal por punto
        let s = String(val).replace(/\./g, '').replace(',', '.');
        return parseFloat(s) || 0;
    };

    proyeccionCompleta.forEach((periodo, index) => {
        const noCuotaDisplay = periodo.noCuota;

        // 1. OBTENER VALORES BASE
        // Intentamos leer el valor UVR, si no existe, leemos el valor normal
        let vCuota = limpiar(props.moneda === "uvr" ? periodo.vlrCuotaUVR : periodo.vlrCuota);

        // Aquí está el truco: Leemos el interés que viene (probablemente en Pesos)
        let vInteresRaw = limpiar(periodo.interesUVR || periodo.interes);
        let vInteres = vInteresRaw;

        // 2. CORRECCIÓN AUTOMÁTICA DE MONEDA
        // Si es UVR y el interés es absurdamente grande comparado con la cuota...
        if (props.moneda === "uvr") {
            // Si el interés es mayor que la cuota total, es obvio que está en Pesos
            if (vInteres > vCuota) {
                // Lo dividimos por el valor de la unidad que calculamos arriba
                vInteres = vInteresRaw / valorUnidadCalculado;
            }
        }

        // 3. CALCULAR ABONO (Cuota - Interés corregido)
        const vAbono = (periodo.noCuota === 0) ? 0 : (vCuota - vInteres);

        // 4. CALCULAR SALDO ARRASTRADO
        if (periodo.noCuota === 0) {
            saldoAcumulado = limpiar(props.moneda === "uvr" ? periodo.saldoUVR : periodo.saldo);
            // Si el saldo inicial viene mal o es 0, usamos el valor del préstamo
            if (saldoAcumulado === 0) saldoAcumulado = montoUVR;
        } else {
            saldoAcumulado = saldoAcumulado - vAbono;
        }

        // Evitar saldos negativos infinitesimales (-0.00001)
        if (saldoAcumulado < 0) saldoAcumulado = 0;

        // ============================================
        // CONSTRUIR ALTURA DE CUOTA
        // ============================================
        altura_cuota.push({
            "NUMERO CUOTA": {
                text: noCuotaDisplay,
                fontSize: 9
            },
        });

        // ============================================
        // CONSTRUIR DATOS CENTRALES (PROYECCIÓN)
        // ============================================
        if (props.moneda === "uvr") {
            // Para créditos en UVR
            datos_centrales.push({
                "CUOTA EN UVR": {
                    text: vCuota.toLocaleString('es-CO', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) + " UVR",
                    fontSize: 9, alignment: "right"
                },
                "INTERESES EN UVR": {
                    text: vInteres.toLocaleString('es-CO', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) + " UVR",
                    fontSize: 9, alignment: "right"
                },
                "ABONO EN UVR": {
                    text: vAbono.toLocaleString('es-CO', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) + " UVR",
                    fontSize: 9, alignment: "right"
                },
                "SALDO EN UVR": {
                    text: saldoAcumulado.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " UVR",
                    fontSize: 9, alignment: "right"
                },
            });
        } else {
            // Para créditos en PESOS
            datos_centrales.push({
                "CUOTA EN PESOS": {
                    text: "$" + formatNumber(parseFloat(periodo.vlrCuota) || 0),
                    fontSize: 9, alignment: "right"
                },
                "INTERESES EN PESOS": {
                    text: "$" + formatNumber(parseFloat(periodo.interes) || 0),
                    fontSize: 9, alignment: "right"
                },
                "ABONO EN PESOS": {
                    text: "$" + formatNumber(calcularAbonoPesos(index)),
                    fontSize: 9, alignment: "right"
                },
                "SALDO EN PESOS": {
                    text: "$" + formatNumber(calcularSaldoProyectadoPesos(index)),
                    fontSize: 9, alignment: "right"
                },
            });
        }
    });

    // ============================================
    // CONSTRUCCIÓN DE TABLAS PARA EL PDF
    // ============================================
    var tablaAltura = table(altura_cuota, ["NUMERO CUOTA"], "B");
    tablaAltura.table.widths = ["*"];

    var headLine;
    var tablaProy;
    var columnasHeaderDoc = [];
    var filasHeaderDoc = [];

    if (props.moneda === "uvr") {
        ("Total registros para UVR:", datos_centrales.length);
        tablaProy = table(
            datos_centrales,
            [
                "CUOTA EN UVR",
                "INTERESES EN UVR",
                "ABONO EN UVR",
                "SALDO EN UVR",
            ],
            "A"
        );
        tablaProy.table.widths = ["*", "*", "*", "*"];

        // Tabla interna para el header (tipo "D")
        var tablaInternaUVR = table(
            datos_centrales,
            [
                "CUOTA EN UVR",
                "INTERESES EN UVR",
                "ABONO EN UVR",
                "SALDO EN UVR",
            ],
            "D"
        );
        tablaInternaUVR.table.widths = ["*", "*", "*", "*"];

        // Construir headLine
        headLine = [
            { text: "NUMERO DE CUOTA", fontSize: 12, bold: true },
            [
                { text: "UNIDAD DE VALOR REAL", alignment: "center", fontSize: 12, bold: true },
                tablaInternaUVR
            ],
        ];

        // Datos del header del documento
        columnasHeaderDoc.push(
            {
                lineHeight: 1,
                text: "PLAZO:",
                style: "textBold",
            },
            {
                lineHeight: 1,
                text: "VALOR PRESTAMO:",
                style: "textBold",
            },
            {
                lineHeight: 1,
                text: "VALOR EN PESOS:",
                style: "textBold",
            },
            {
                lineHeight: 1,
                text: "PAGO MENSUAL:",
                style: "textBold",
            },
            {
                lineHeight: 1,
                text: "INTERES:",
                style: "textBold",
            }
        );

        const capitalUVR = parseValue(auxProps.vlrInicialUVR) || parseValue(auxProps.vlrCapProyectado) || 0;
        const capitalPesos = parseValue(auxProps.vlrInicial) || 0;
        const cuotaUVR = parseFloat(
            proyeccionCompleta[1]?.vlrCuotaUVR || proyeccionCompleta[1]?.vlrCuota || 0
        );
        const tasa = parseValue(auxProps.interes) || 0;

        filasHeaderDoc.push(
            {
                lineHeight: 1,
                text: (proyeccionCompleta.length - 1) + " Meses",
                style: "text",
            },
            {
                lineHeight: 1,
                text: capitalUVR > 0
                    ? capitalUVR.toLocaleString(undefined, { maximumFractionDigits: 2 }) + " UVR"
                    : "0 UVR",
                style: "text",
            },
            {
                lineHeight: 1,
                text: capitalPesos > 0
                    ? "$" + formatNumber(capitalPesos)
                    : "$0",
                style: "text",
            },
            {
                lineHeight: 1,
                text: cuotaUVR > 0
                    ? cuotaUVR.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " UVR"
                    : "0 UVR",
                style: "text",
            },
            {
                lineHeight: 1,
                text: tasa > 0 ? tasa + " % E.A." : "0 % E.A.",
                style: "text",
            }
        );

    } else {
        // ============================================
        // PARA PESOS
        // ============================================

        // Tabla principal de proyección (tipo "A")
        tablaProy = table(
            datos_centrales,
            [
                "CUOTA EN PESOS",
                "INTERESES EN PESOS",
                "ABONO EN PESOS",
                "SALDO EN PESOS",
            ],
            "A"
        );
        tablaProy.table.widths = ["*", "*", "*", "*"];

        // Tabla interna para el header (tipo "D")
        var tablaInternaPesos = table(
            datos_centrales,
            [
                "CUOTA EN PESOS",
                "INTERESES EN PESOS",
                "ABONO EN PESOS",
                "SALDO EN PESOS",
            ],
            "D"
        );
        tablaInternaPesos.table.widths = ["*", "*", "*", "*"];

        // Construir headLine
        headLine = [
            { text: "NUMERO DE CUOTA", alignment: "center", fontSize: 12, bold: true },
            [
                { text: "PESOS", alignment: "center", fontSize: 12, bold: true },
                tablaInternaPesos
            ],
        ];

        // Datos del header del documento
        columnasHeaderDoc.push(
            {
                lineHeight: 1,
                text: "PLAZO:",
                style: "textBold",
            },
            {
                lineHeight: 1,
                text: "VALOR PRESTAMO:",
                style: "textBold",
            },
            {
                lineHeight: 1,
                text: "PAGO MENSUAL:",
                style: "textBold",
            },
            {
                lineHeight: 1,
                text: "INTERES:",
                style: "textBold",
            }
        );

        const capitalPesos = parseValue(auxProps.vlrInicial) || 0;
        const cuotaPesos = parseFloat(
            proyeccionCompleta[1]?.vlrCuota || 0
        );
        const tasa = parseValue(auxProps.interes) || 0;

        filasHeaderDoc.push(
            {
                lineHeight: 1,
                text: (proyeccionCompleta.length - 1) + " Meses",
                style: "text",
            },
            {
                lineHeight: 1,
                text: capitalPesos > 0
                    ? "$" + formatNumber(capitalPesos)
                    : "$0",
                style: "text",
            },
            {
                lineHeight: 1,
                text: cuotaPesos > 0
                    ? "$" + formatNumber(cuotaPesos)
                    : "$0",
                style: "text",
            },
            {
                lineHeight: 1,
                text: tasa > 0 ? tasa + " % E.A." : "0 % E.A.",
                style: "text",
            }
        );
    }

    // ============================================
    // RESTO DE LA DEFINICIÓN DEL PDF
    // ============================================
    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [40, 300, 40, 200],
        header: function (currentPage, pageCount, pageSize) {
            return [
                // ====================================
                // RECTÁNGULO ROJO DE FONDO (ANCHO COMPLETO)
                // ====================================
                {
                    margin: [0, 0, 0, 10],
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: 612,
                            h: 76,
                            color: "#e92128",
                        },
                    ],
                },
                // ====================================
                // BARRA GRIS SUPERIOR (ANCHO COMPLETO)
                // ====================================
                {
                    margin: [0, 0, 0, 10],
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: -20,
                            w: 612,
                            h: 5,
                            color: "#B9B9B9",
                        },
                    ],
                },
                // ====================================
                // LOGO (CENTRADO)
                // ====================================
                {
                    width: 100,
                    image: logo,
                    alignment: "center",
                    absolutePosition: { y: 15, x: -120 },
                },
                // ====================================
                // TEXTO "INMOBILIARIA" (CENTRADO)
                // ====================================
                {
                    text: "INMOBILIARIA",
                    style: "title1",
                    absolutePosition: { x: 310, y: 20 },
                },
                // ====================================
                // TEXTO "MOBILIA" (CENTRADO)
                // ====================================
                {
                    text: "MOBILIA",
                    style: "title2",
                    absolutePosition: { x: 310, y: 42 },
                },
                // ====================================
                // TÍTULO: "PROYECCIÓN DEL CRÉDITO"
                // ====================================
                {
                    margin: [40, 0, 0, 0],
                    lineHeight: 1.3,
                    text: "PROYECCIÓN DEL CRÉDITO",
                    style: "textBold",
                },
                // ====================================
                // LÍNEA ROJA DEBAJO DEL TÍTULO
                // ====================================
                {
                    margin: [40, 0, 0, 5],
                    canvas: [
                        {
                            type: "line",
                            x1: 0,
                            y1: 0,
                            x2: 530,
                            y2: 0,
                            lineWidth: 3,
                            lineColor: "red",
                        },
                    ],
                },
                // ====================================
                // SUBTÍTULO: "INMOBILIARIA MOBILIA S.A"
                // ====================================
                {
                    margin: [40, 0, 0, 0],
                    lineHeight: 2.5,
                    text: "INMOBILIARIA MOBILIA S.A",
                    style: "redText",
                },
                // ====================================
                // TEXTO: "OBLIGACIÓN HIPOTECARIA NÚMERO"
                // ====================================
                {
                    margin: [40, 0, 0, 0],
                    lineHeight: 2,
                    text: "OBLIGACION HIPOTECARIA NUMERO:",
                    style: "textBold",
                },
                // ====================================
                // RECTÁNGULO GRIS PARA EL NÚMERO
                // ====================================
                {
                    absolutePosition: { y: 124, x: 405 },
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: 150,
                            h: 30,
                            color: "#DCDDDF",
                        },
                    ],
                },
                // ====================================
                // NÚMERO DE OBLIGACIÓN
                // ====================================
                {
                    lineHeight: 1,
                    text: auxProps.financialCode || auxProps.id || "",
                    style: "textBold",
                    alignment: "left",
                    absolutePosition: { y: 134, x: 450 },
                },
                // ====================================
                // LÍNEA ROJA SEPARADORA
                // ====================================
                {
                    margin: [40, 0, 0, 5],
                    canvas: [
                        {
                            type: "line",
                            x1: 0,
                            y1: 0,
                            x2: 530,
                            y2: 0,
                            lineWidth: 3,
                            lineColor: "red",
                        },
                    ],
                },
                // ====================================
                // TABLA CON DATOS DEL CLIENTE
                // ====================================
                {
                    margin: [40, 10, 40, 0],
                    table: {
                        body: [
                            [
                                {
                                    fillColor: "#DCDDDF",
                                    border: [false, false, false, false],
                                    columns: [
                                        {
                                            width: 300,
                                            stack: [
                                                {
                                                    lineHeight: 1.5,
                                                    text: "CLIENTE:",
                                                    style: "textBold",
                                                },
                                                {
                                                    lineHeight: 1.5,
                                                    text: (auxProps.clientesData && auxProps.clientesData[0] && auxProps.clientesData[0].nombre) || "Cliente",
                                                    style: "textBold",
                                                },
                                                {
                                                    lineHeight: 1.5,
                                                    text: (auxProps.clientesData && auxProps.clientesData[0] && auxProps.clientesData[0].direccion) || "",
                                                    style: "text",
                                                },
                                            ],
                                        },
                                        {
                                            width: "auto",
                                            columns: [
                                                {
                                                    stack: [columnasHeaderDoc],
                                                },
                                                {
                                                    stack: [filasHeaderDoc],
                                                },
                                            ],
                                            columnGap: 10,
                                        },
                                    ],
                                    columnGap: 30,
                                },
                            ],
                        ],
                    },
                },
                // ====================================
                // TÍTULO DE LA SECCIÓN DE PROYECCIÓN
                // ====================================
                {
                    margin: [40, 10, 40, 0],
                    table: {
                        widths: ["*"],
                        body: [
                            [
                                {
                                    fontSize: 10,
                                    fillColor: "#DCDDDF",
                                    border: [false, false, false, false],
                                    alignment: "center",
                                    margin: [0, 7, 0, 7],
                                    columns: [
                                        {
                                            text: "SALDO, CUOTA Y PROYECCIONES DEL CRÉDITO",
                                            bold: true,
                                        },
                                    ],
                                },
                            ],
                        ],
                    },
                },
            ];
        },
        footer: function () {
            return [
                {
                    absolutePosition: { y: 60, x: 0 },
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: 700,
                            h: 78,
                            color: "#DCDDDF",
                        },
                    ],
                },
                {
                    lineHeight: 2,
                    text: "FORMA DE PAGO",
                    style: "textBold",
                    alignment: "center",
                    absolutePosition: { x: 0, y: 72 },
                },
                {
                    absolutePosition: { x: 20, y: 93 },
                    margin: [40, 0, 0, 40],
                    canvas: [
                        {
                            type: "line",
                            x1: 0,
                            y1: 0,
                            x2: 515,
                            y2: 0,
                            lineWidth: 3,
                            lineColor: "red",
                        },
                    ],
                },
                {
                    absolutePosition: { y: 100, x: 0 },
                    lineHeight: 1.2,
                    text: "Su pago lo puede efectuar en el Banco Caja Social Cuenta convenio No. 11542 \na nombre de Inmobiliaria Mobilia S.A. En cualquier ciudad del país",
                    style: "textBold",
                    alignment: "center",
                },
                {
                    width: 700,
                    image: footer,
                    alignment: "center",
                    absolutePosition: { y: 128, x: 85 },
                },
            ];
        },
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: [60, "*"],
                    body: [
                        headLine,
                        [
                            {
                                table: tablaAltura.table
                            },
                            {
                                table: tablaProy.table,
                                layout: tablaProy.layout
                            }
                        ],
                    ],
                    dontBreakRows: false,
                },
                alignment: "center",
            },
        ],
        styles: {
            subtitle: {
                fontSize: 10,
                bold: true,
            },
            text: {
                fontSize: 10,
                bold: false,
            },
            textBoldTable: {
                fontSize: 9,
                bold: true,
            },
            headerPago: {
                fontSize: 10,
                bold: false,
            },
            textBold: {
                fontSize: 10,
                bold: true,
            },
            tableHeader: {
                fontSize: 8,
                bold: true,
            },
            tableHeaderColor: {
                fontSize: 8,
                bold: true,
                color: "white",
                fillColor: "#e92128",
            },
            redText: {
                fontSize: 10,
                bold: true,
                color: "#e92128",
            },
            tableExample: {
                fontSize: 8,
                color: "black",
            },
            tableExample2: {
                fontSize: 9,
                color: "black",
            },
            title1: {
                fontSize: 15,
                color: "white",
            },
            title2: {
                fontSize: 20,
                bold: true,
                color: "white",
            },
        },
    };

    pdfMake.createPdf(docDefinition).download(`proyeccion_${props.id}.pdf`);
};

export const generatePDF = async (props, { table, formatter, toFixed, fixTimeZone, parseFlexibleDate, toast, setState, delPago, logo, footer, apiMethods }) => {

    let actUsrToken = window.sessionStorage.getItem("localToken");
    var elementos = document.getElementsByClassName("selectorDownload");
    if (window.sessionStorage.getItem("initialPDF") == "true") {
        var periodo = 0;
    } else {
        var periodo = parseFloat(
            elementos.estado.selectedOptions[0].id.replace(/\D/g, "")
        );
    }
    var savePeriodo = periodo;

    const months = [
        "ENE",
        "FEB",
        "MAR",
        "ABR",
        "MAY",
        "JUN",
        "JUL",
        "AGO",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
    ];
    const normalizeMonthText = (text) =>
        String(text || "")
            .toUpperCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

    const monthIndexMap = {
        ENE: 0,
        ENERO: 0,
        FEB: 1,
        FEBRERO: 1,
        MAR: 2,
        MARZO: 2,
        ABR: 3,
        ABRIL: 3,
        MAY: 4,
        MAYO: 4,
        JUN: 5,
        JUNIO: 5,
        JUL: 6,
        JULIO: 6,
        AGO: 7,
        AGOSTO: 7,
        SEP: 8,
        SEPT: 8,
        SEPTIEMBRE: 8,
        OCT: 9,
        OCTUBRE: 9,
        NOV: 10,
        NOVIEMBRE: 10,
        DIC: 11,
        DICIEMBRE: 11,
        DEC: 11,
    };

    const parsePeriodoLabel = (label) => {
        if (!label) return null;
        const matches = [...label.matchAll(/(\d{2})\s+DE\s+([A-Z]+)\s+DE\s+(\d{4})/gi)];
        if (!matches.length) return null;
        const last = matches[matches.length - 1];
        return {
            day: last[1],
            monthText: last[2],
            year: last[3],
        };
    };

    const selectedLabel = elementos.estado?.selectedOptions?.[0]?.value || "";
    const parsedLabel = parsePeriodoLabel(selectedLabel);
    if (!parsedLabel) {
        toast.error("No se pudo interpretar el periodo seleccionado");
        return;
    }

    var auxDia = parsedLabel.day;
    var auxMesText = normalizeMonthText(parsedLabel.monthText);
    var auxMes = monthIndexMap[auxMesText];
    var auxAnio = parsedLabel.year;

    if (auxMes == null) {
        toast.error("No se pudo interpretar el mes del periodo seleccionado");
        return;
    }

    auxMes++;

    if (window.sessionStorage.getItem("initialPDF") == "true") {

        auxMes--;
    }

    if (auxMes == 1) {
        auxMes = 12;
        auxAnio = (parseFloat(auxAnio) - 1).toString();
    }

    if (auxMes < 10) {
        auxMes = "0" + auxMes;
    }

    let auxIni = fixTimeZone(new Date(props.proyeccion[periodo].fechaIni));
    let auxFin = fixTimeZone(new Date(props.proyeccion[periodo].fechaFin));

    var fechasPeriodo =
        ("0" + (auxIni.getDate() + 1)).slice(-2) +
        " " +
        months[auxIni.getMonth()] +
        " " +
        auxIni.getFullYear() +
        " al " +
        ("0" + auxFin.getDate()).slice(-2) +
        " " +
        months[auxFin.getMonth()] +
        " " +
        auxFin.getFullYear();

    var auxInit = new Date(
        props.transacciones[props.transacciones.length - 1].fechaTx
    );
    auxInit.setMonth(auxInit.getMonth() + 1);
    // Ensure fechaDesembolso is a Date before calling getDate()
    let fechaDesembolsoDate = props.fechaDesembolso;
    if (typeof fechaDesembolsoDate === "string" || typeof fechaDesembolsoDate === "number") {
        fechaDesembolsoDate = new Date(fechaDesembolsoDate);
    }
    if (fechaDesembolsoDate && typeof fechaDesembolsoDate.getDate === "function") {
        auxInit.setDate(fechaDesembolsoDate.getDate());
    }

    var year = auxInit.getFullYear();
    var month = auxInit.getMonth();
    var dt = auxInit.getDate();

    if (dt < 10) {
        dt = "0" + dt;
    }
    if (month < 10) {
        month = "0" + month;
    }
    var parsedDate = dt + "-" + month + "-" + year;

    const response = await axios.get(apiMethods.GET_UVR_FECHA + parsedDate, {
        headers: { Authorization: actUsrToken },
    });

    var auxProxCorte = new Date(props.auxProxCorte);

    var year = auxProxCorte.getFullYear();
    var month = auxProxCorte.getMonth() + 1;
    var dt = auxProxCorte.getDate();

    if (dt < 10) {
        dt = "0" + dt;
    }
    if (month < 10) {
        month = "0" + month;
    }
    var parsedDate = auxDia + "-" + auxMes + "-" + auxAnio;

    var fechaPago = props.fechaPago;
    if (response.data.valor) {
        var vlrUVRInitAux = response.data.uvr[0].valor;
        var vlrUVRInit = parseFloat(vlrUVRInitAux);
    }

    var parsedDate2 =
        ("0" + auxFin.getDate()).slice(-2) +
        "-" +
        ("0" + (auxFin.getMonth() + 1)).slice(-2) +
        "-" +
        auxFin.getFullYear();
    const response2 = await axios.get(apiMethods.GET_UVR_FECHA + parsedDate2, {
        headers: { Authorization: actUsrToken },
    });

    var fechaPago2 = props.fechaPago;
    if (response2.data.uvr || props.moneda == "pesos") {
        if (props.moneda == "uvr") {
            var vlrUVRInitAux2 = response2.data.uvr[0].valor;
            var vlrUVRInit2 = parseFloat(vlrUVRInitAux2);
        }

        var transacciones = props.transaccionesData;
        var auxTxAbs = [];
        var headers = [
            "Periodo",
            "Pagos realizados en el periodo",
            "Capital",
            "Interés Corriente",
            "Interés Moratorio",
            "Seguro de vida",
            "Seguro de incendio y todo riesgo",
        ];
        var auxHeaders = [];

        for (let i = 0; i < 7; i++) {
            var auxHeader = {
                text: headers[i],
                style: ["tableHeader"],
            };
            auxHeaders.push(auxHeader);
        }
        auxTxAbs.push(auxHeaders);

        var clientes = [];

        for (let i = 1; i < props.clientesData.length; i++) {
            var title = {
                lineHeight: 1,
                text: "APRECIADO CLIENTE",
                style: "text",
            };
            clientes.push(title);

            var nombre = {
                lineHeight: 1,
                text: [props.clientesData[i].nombre],
                style: "textBold",
            };

            clientes.push(nombre);

            var direccion = {
                lineHeight: 2,
                text: [props.clientesData[i].direccion],
                style: "text",
            };

            clientes.push(direccion);
        }

        var paymentsHeader = [
            {
                text: "PAGOS RECIBIDOS EN ESTE PERIODO",
                alignment: "center",
                colSpan: 2,
                border: [false, false, false, false],
            },
            {},
        ];

        var paymentsBody = [];

        var neededPayments = [];
        var neededPaymentsData = [];

        var auxPeriodo = periodo;

        var fechaDesembolsoReal;

        if (
            props.liquidaciones[0].interesCorriente != 0 ||
            props.liquidaciones[0].interesMoratorio != 0 ||
            props.liquidaciones[0].segVida != 0 ||
            props.liquidaciones[0].segTodoRiesgo != 0
        ) {
            var sumMora = 0;
            // Usar parseFlexibleDate (soporta varios formatos) y validar
            var auxFecha = parseFlexibleDate(props.fechaInicial);
            if (!auxFecha || isNaN(auxFecha.getTime())) {
                // Intentar fallback con constructor Date por si viene otro formato
                auxFecha = props.fechaInicial ? new Date(props.fechaInicial) : null;
            }

            if (auxFecha && !isNaN(auxFecha.getTime())) {
                fechaDesembolsoReal =
                    new Intl.DateTimeFormat("en", { day: "2-digit", timeZone: "UTC" }).format(
                        auxFecha
                    ) +
                    " de " +
                    new Intl.DateTimeFormat("es", { month: "long", timeZone: "UTC" }).format(
                        auxFecha
                    ) +
                    " " +
                    new Intl.DateTimeFormat("en", { year: "numeric", timeZone: "UTC" }).format(
                        auxFecha
                    );
            } else {
                // Valor por defecto si no se puede parsear la fecha
                fechaDesembolsoReal = "";
            }

            for (let i = 0; i < props.transacciones.length; i++) {
                sumMora = sumMora + props.transacciones[i].mesesEnMora;
            }

            var cntCuotas = 0;

            for (let i = 0; i < props.liquidacionesData.length; i++) {
                if (props.liquidacionesData[i].pagosTotal != 0) {
                    cntCuotas++;
                }
            }

            if (cntCuotas == sumMora && props.transacciones.length > 1) {
                sumMora--;
            }

            var sum = 0;
        } else {
            // Ensure props.fechaDesembolso is a valid Date before formatting
            let fd = props.fechaDesembolso;
            let fdDate = null;
            if (fd instanceof Date) {
                fdDate = fd;
            } else if (fd) {
                fdDate = new Date(fd);
            }

            if (fdDate && !isNaN(fdDate.getTime())) {
                fechaDesembolsoReal =
                    new Intl.DateTimeFormat("en", { day: "2-digit", timeZone: "UTC" }).format(
                        fdDate
                    ) +
                    " de " +
                    new Intl.DateTimeFormat("es", { month: "long", timeZone: "UTC" }).format(
                        fdDate
                    ) +
                    " " +
                    new Intl.DateTimeFormat("en", { year: "numeric", timeZone: "UTC" }).format(
                        fdDate
                    );
            } else {
                fechaDesembolsoReal = "";
            }
        }

        var neededLiq = [];
        var sumMoraTx = 0;

        for (let i = 0; i <= periodo; i++) {
            if (props.proyeccion[i].presentaPagos == false) {
                sumMoraTx++;
            }
        }

        if (props.proyeccion[0].liquidado == false) {
            sumMoraTx--;
        }

        if (sumMoraTx < 0) {
            sumMoraTx = 0;
        }

        var cntCero = 0;

        for (let i = 0; i < props.transacciones.length; i++) {
            if (props.transacciones[i].vlrTx == 0) {
                cntCero++;
            }
        }

        periodo = periodo - cntCero;

        if (periodo < 0) {
            periodo = 0;
        }

        var genPago = props.transacciones[periodo - sumMoraTx];

        for (let i = 0; i < props.transacciones.length; i++) {
            if (props.proyeccionData[0].liquidado == true) {
                if (props.transacciones[i].cuota == savePeriodo) {
                    neededPayments.push(props.transacciones[i]);
                }
            } else {
                if (props.transacciones[i].cuota == savePeriodo) {
                    neededPayments.push(props.transacciones[i]);
                }
            }
        }

        var cero = false;
        var normal = false;

        for (let i = 0; i < neededPayments.length; i++) {
            if (neededPayments[i].vlrTx == 0) {
                cero = true;
            } else {
                normal = true;
            }
        }

        if (cero && normal) {
            // Recorrer en orden inverso para eliminar sin saltar índices
            for (let i = neededPayments.length - 1; i >= 0; i--) {
                if (neededPayments[i].vlrTx == 0) {
                    neededPayments.splice(i, 1);
                }
            }
        }

        for (let i = 0; i < neededPayments.length; i++) {
            neededLiq.push(props.liquidaciones[neededPayments[i].id + 1]);
        }

        var auxFechaFinPeriodo = new Date(
            props.proyeccion[neededPayments[0].cuota].fechaFin
        );
        auxFechaFinPeriodo = fixTimeZone(new Date(auxFechaFinPeriodo));
        auxFechaFinPeriodo.setMonth(auxFechaFinPeriodo.getMonth() + 1);
        auxFechaFinPeriodo.setHours(0, 0, 0, 0);

        var fechaCompleta =
            ("0" + auxFechaFinPeriodo.getDate()).slice(-2) +
            "/" +
            ("0" + (auxFechaFinPeriodo.getMonth() + 1)).slice(-2) +
            "/" +
            auxFechaFinPeriodo.getFullYear();
        var sumIntCteGen = 0;
        var sumIntMoraGen = 0;
        var sumIntCteGenUVR = 0;
        var sumIntMoraGenUVR = 0;
        var sumSegGen = 0;

        var sumIntCteApl = 0;
        var sumIntMoraApl = 0;
        var sumSegApl = 0;
        var sumCapApl = 0;

        var sumIntCteAplUVR = 0;
        var sumIntMoraAplUVR = 0;
        var sumCapAplUVR = 0;

        for (let i = 0; i < neededPaymentsData.length; i++) {
            sumIntCteGen =
                sumIntCteGen + neededPaymentsData[i].genInteresCorriente;
            sumIntMoraGen =
                sumIntMoraGen + neededPaymentsData[i].genInteresMoratorio;
            sumSegGen =
                sumSegGen +
                neededPaymentsData[i].genSeguroVida +
                neededPaymentsData[i].genSeguroTodoRiesgo;

            sumCapApl =
                sumCapApl + neededPaymentsData[i].vlrAplicadoCapital;
            sumIntCteApl =
                sumIntCteApl + neededPaymentsData[i].vlrAplicadoIntCte;
            sumIntMoraApl =
                sumIntMoraApl + neededPaymentsData[i].vlrAplicadoIntMora;
            sumSegApl =
                sumSegApl +
                neededPaymentsData[i].vlrAplicadoSegVida +
                neededPaymentsData[i].vlrAplicadoSegTodoRiesgo;

            if (props.moneda == "uvr") {
                sumIntCteGenUVR =
                    sumIntCteGenUVR +
                    neededPaymentsData[i].genInteresCorrienteUVR;
                sumIntMoraGenUVR =
                    sumIntMoraGenUVR +
                    neededPaymentsData[i].genInteresMoratorioUVR;

                sumCapAplUVR =
                    sumCapAplUVR + neededPaymentsData[i].vlrAplicadoCapitalUVR;
                sumIntCteAplUVR =
                    sumIntCteAplUVR +
                    neededPaymentsData[i].vlrAplicadoIntCteUVR;
                sumIntMoraAplUVR =
                    sumIntMoraAplUVR +
                    neededPaymentsData[i].vlrAplicadoIntMoraUVR;
            }
        }

        var auxLiquidacionPrev;
        var auxLiquidacionPost;

        auxLiquidacionPost =
            props.liquidaciones[
            neededPayments[0].id + props.pagosPorCreditos[auxPeriodo - 1]
            ];

        // finalPeriodLiq: liq after the very last transaction in this period (including $0 closings filtered from neededPayments)
        const periodCuota = neededPayments[0].cuota;
        let lastPeriodTxId = neededPayments[0].id;
        for (let t = 0; t < props.transacciones.length; t++) {
            if (props.transacciones[t].cuota === periodCuota) {
                lastPeriodTxId = props.transacciones[t].id;
            }
        }
        const finalPeriodLiq = props.liquidaciones[lastPeriodTxId + 1] || auxLiquidacionPost;

        for (let i = 0; i < neededPayments.length; i++) {
            paymentsBody.push({
                Fecha: neededPayments[i].fechaTx,
                Monto: "$" + neededPayments[i].vlrTx,
            });
        }

        // ----- cálculo de próxima cuota (fix formato números) -----
        const parseFlexibleNumber = (v) => {
            if (v === null || v === undefined || v === "") return 0;
            if (typeof v === "number") return v;
            let s = String(v).replace(/\s|\$|COP|USD|UVR/gi, "");
            const hasComma = s.includes(",");
            const hasDot = s.includes(".");
            if (hasComma && hasDot) {
                if (s.lastIndexOf(",") > s.lastIndexOf(".")) {
                    s = s.replace(/\./g, "").replace(",", ".");
                } else {
                    s = s.replace(/,/g, "");
                }
            } else if (hasComma) {
                const parts = s.split(",");
                if (parts[1] && parts[1].length <= 2) {
                    s = parts[0].replace(/,/g, "") + "." + parts[1];
                } else {
                    s = s.replace(/,/g, "");
                }
            } else if (hasDot) {
                const parts = s.split(".");
                if (parts[1] && parts[1].length > 2) {
                    s = s.replace(/\./g, "");
                }
            }
            const n = Number(s);
            return Number.isFinite(n) ? n : 0;
        };

        const getResumenPeriodo = (source) => {
            const periodoSeleccionado =
                props.proyeccionData?.[auxPeriodo]?.periodo ||
                props.proyeccion?.[auxPeriodo]?.periodo ||
                props.proyeccionData?.[savePeriodo]?.periodo ||
                props.proyeccion?.[savePeriodo]?.periodo ||
                null;

            if (periodoSeleccionado) {
                const matchedIdx = source?.findIndex(
                    (item) => item?.periodo === periodoSeleccionado
                );
                if (matchedIdx >= 0) {
                    return { item: source?.[matchedIdx] || {}, idx: matchedIdx };
                }
            }

            const candidates = [
                auxPeriodo,
                auxPeriodo - 1,
                savePeriodo,
                savePeriodo - 1,
                lastCuota,
                lastCuota + 1,
            ].filter((idx, pos, arr) => idx >= 0 && arr.indexOf(idx) === pos);

            for (const idx of candidates) {
                const item = source?.[idx];
                if (!item) continue;

                const hasValues = [
                    item.capital,
                    item.interesCorriente,
                    item.interesMoratorio,
                    item.segVida,
                    item.segTodoRiesgo,
                ].some((value) => parseFlexibleNumber(value) !== 0);

                if (hasValues) {
                    return { item, idx };
                }
            }

            const fallbackIdx = candidates[0] ?? 0;
            return { item: source?.[fallbackIdx] || {}, idx: fallbackIdx };
        };

        const lastCuota =
            neededPayments?.[neededPayments.length - 1]?.cuota ?? -1;
        const idxProx = lastCuota;
        const hasNext =
            !!props.proyeccion[idxProx] &&
            idxProx <= parseFloat(props.plazo);
        let auxVlrCuota = null;
        if (hasNext) {
            if (props.moneda === "uvr") {
                let vlrUVRProxCuota = vlrUVRInit2;
                try {
                    const fechaFinProx = new Date(props.proyeccion[idxProx].fechaFin);
                    const dProx = ("0" + fechaFinProx.getUTCDate()).slice(-2);
                    const mProx = ("0" + (fechaFinProx.getUTCMonth() + 1)).slice(-2);
                    const aProx = fechaFinProx.getUTCFullYear();
                    const parsedDateProx = `${dProx}-${mProx}-${aProx}`;

                    const response3 = await axios.get(apiMethods.GET_UVR_FECHA + parsedDateProx, {
                        headers: { Authorization: actUsrToken }
                    });

                    if (response3.data?.uvr?.[0]?.valor) {
                        vlrUVRProxCuota = parseFloat(response3.data.uvr[0].valor);
                    }
                } catch (e) {
                    console.error("Error en tercera llamada:", e);
                }
                auxVlrCuota =
                    parseFlexibleNumber(props.proyeccion[idxProx].vlrCuotaUVR) *
                    vlrUVRProxCuota;// UVR correcto
            } else {
                auxVlrCuota = parseFlexibleNumber(
                    props.proyeccion[idxProx].vlrCuota
                );
            }
            auxVlrCuota += parseFlexibleNumber(
                props.proyeccion[idxProx].segVida
            );
            auxVlrCuota += parseFlexibleNumber(
                props.proyeccion[idxProx].segTodoRiesgo
            );
        }
        // ----------------------------------------------------------

        if (props.moneda === "uvr") {
            var cuotaIdx = neededPayments[neededPayments.length - 1].cuota + 1;
            var actualCapitalUVR = parseFloat(neededLiq[neededLiq.length - 1].capitalUVR);
            var capitalProxCorteVal = parseFloat(neededLiq[neededLiq.length - 1].capitalProxCorte) || 0;
            var auxProy = 0;

            console.log('[MORA-UVR] ── BLOQUE 1: capital en mora UVR ──');
            console.log('[MORA-UVR] cuotaIdx:', cuotaIdx, '| plazo:', props.plazo);
            console.log('[MORA-UVR] actualCapitalUVR (neededLiq último):', actualCapitalUVR);
            console.log('[MORA-UVR] capitalProxCorteVal (neededLiq último):', capitalProxCorteVal);
            console.log('[MORA-UVR] normal:', normal);

            // Solo usar proyección si el índice es válido y no excede el plazo
            if (
                cuotaIdx > 0 &&
                cuotaIdx <= parseFloat(props.plazo) &&
                props.proyeccion[cuotaIdx]
            ) {
                var auxProyCandidate = parseFloat(
                    props.proyeccion[cuotaIdx].vlrCapitalUVR
                );
                console.log('[MORA-UVR] proyeccion[cuotaIdx].vlrCapitalUVR:', auxProyCandidate, '| ratio:', actualCapitalUVR > 0 ? (auxProyCandidate / actualCapitalUVR).toFixed(4) : 'N/A');
                if (!normal && actualCapitalUVR > 0 && auxProyCandidate / actualCapitalUVR > 0.9) {
                    console.log('[MORA-UVR] ⚠ sanity check activo → auxProy forzado a 0');
                    auxProy = 0;
                } else {
                    auxProy = auxProyCandidate;
                }
            } else {
                console.log('[MORA-UVR] ⚠ proyeccion[cuotaIdx] no existe → auxProy = 0');
            }

            var capitalEnMoraUVR = actualCapitalUVR - auxProy;
            console.log('[MORA-UVR] auxProy:', auxProy, '| capitalEnMoraUVR (antes clamp):', capitalEnMoraUVR);

            if (capitalEnMoraUVR < 1) {
                capitalEnMoraUVR = 0;
            }
            console.log('[MORA-UVR] capitalEnMoraUVR (después clamp <1):', capitalEnMoraUVR);

            var capitalEnMora;
            if (capitalEnMoraUVR > 0 && actualCapitalUVR > 0) {
                var uvrRateCorte = capitalProxCorteVal / actualCapitalUVR;
                capitalEnMora = uvrRateCorte * capitalEnMoraUVR;
                console.log('[MORA-UVR] uvrRateCorte (capitalProxCorte/capitalUVR):', uvrRateCorte.toFixed(4), '| capitalEnMora (pesos):', capitalEnMora);
            } else {
                capitalEnMora = 0;
                console.log('[MORA-UVR] capitalEnMora → 0 (capitalEnMoraUVR o actualCapitalUVR es 0)');
            }
            if (capitalEnMora < 0) {
                capitalEnMora = 0;
            }
        } else {
            var cuotaIdx = neededPayments[neededPayments.length - 1].cuota + 1;
            var actualCapital = parseFloat(neededLiq[neededLiq.length - 1].capital);
            var auxProy = 0;

            console.log('[MORA-PESOS] ── BLOQUE 1: capital en mora PESOS ──');
            console.log('[MORA-PESOS] cuotaIdx:', cuotaIdx, '| plazo:', props.plazo);
            console.log('[MORA-PESOS] actualCapital (neededLiq último):', actualCapital);
            console.log('[MORA-PESOS] normal:', normal);

            if (
                cuotaIdx > 0 &&
                cuotaIdx <= parseFloat(props.plazo) &&
                props.proyeccion[cuotaIdx]
            ) {
                var auxProyCandidate = parseFloat(
                    props.proyeccion[cuotaIdx].capital
                );
                console.log('[MORA-PESOS] proyeccion[cuotaIdx].capital:', auxProyCandidate, '| ratio:', actualCapital > 0 ? (auxProyCandidate / actualCapital).toFixed(4) : 'N/A');
                if (!normal && actualCapital > 0 && auxProyCandidate / actualCapital > 0.9) {
                    console.log('[MORA-PESOS] ⚠ sanity check activo → auxProy forzado a 0');
                    auxProy = 0;
                } else {
                    auxProy = auxProyCandidate;
                }
            } else {
                console.log('[MORA-PESOS] ⚠ proyeccion[cuotaIdx] no existe → auxProy = 0');
            }

            var capitalEnMora = actualCapital - auxProy;
            console.log('[MORA-PESOS] auxProy:', auxProy, '| capitalEnMora (antes clamp):', capitalEnMora);

            if (capitalEnMora < 0) {
                capitalEnMora = 0;
            }
            console.log('[MORA-PESOS] capitalEnMora (después clamp):', capitalEnMora);
        }

        if (props.moneda === "uvr") {
            var cuotaActual = neededPayments[neededPayments.length - 1].cuota;
            var actualCapitalUVR = parseFloat(neededLiq[neededLiq.length - 1].capitalUVR);
            var capitalProxCorteVal = parseFloat(neededLiq[neededLiq.length - 1].capitalProxCorte) || 0;

            console.log('[MORA-UVR] ── BLOQUE 2: saldoMora UVR ──');
            console.log('[MORA-UVR] cuotaActual:', cuotaActual, '| indiceSiguiente:', cuotaActual + 1);
            console.log('[MORA-UVR] actualCapitalUVR:', actualCapitalUVR, '| capitalProxCorteVal:', capitalProxCorteVal);

            var capitalProyectadoUVR = 0;

            const indiceSiguiente = cuotaActual + 1;

            if (
                indiceSiguiente >= 0 &&
                indiceSiguiente < parseFloat(props.plazo) &&
                props.proyeccion[indiceSiguiente]
            ) {
                capitalProyectadoUVR = parseFloat(
                    props.proyeccion[indiceSiguiente].vlrCapitalUVR || 0
                );
                console.log('[MORA-UVR] proyeccion[indiceSiguiente].vlrCapitalUVR:', capitalProyectadoUVR);
            } else {
                console.log('[MORA-UVR] ⚠ proyeccion[indiceSiguiente] no existe → capitalProyectadoUVR = 0');
            }

            var capitalEnMoraUVR = actualCapitalUVR - capitalProyectadoUVR;
            console.log('[MORA-UVR] capitalEnMoraUVR (antes clamp):', capitalEnMoraUVR);

            if (capitalEnMoraUVR < 0) {
                capitalEnMoraUVR = 0;
            }
            console.log('[MORA-UVR] capitalEnMoraUVR (después clamp):', capitalEnMoraUVR);

            // Convertir UVR → pesos usando la tasa UVR real de la fecha de corte
            var capitalEnMora = capitalEnMoraUVR * vlrUVRInit2;
            console.log('[MORA-UVR] vlrUVRInit2:', vlrUVRInit2, '| capitalEnMora (pesos):', capitalEnMora);

            console.log('[MORA-UVR] neededLiq.length:', neededLiq.length);
            var interesesParte = parseFloat(finalPeriodLiq?.interesMoratorioCuota || 0);
            var segVidaParte = parseFloat(finalPeriodLiq?.segVida || 0);
            var segTodoRiesgoParte = parseFloat(finalPeriodLiq?.segTodoRiesgo || 0);
            console.log('[MORA-UVR] interesMoratorioCuota (finalPeriodLiq):', finalPeriodLiq?.interesMoratorioCuota, '| segVida:', finalPeriodLiq?.segVida, '| segTR:', finalPeriodLiq?.segTodoRiesgo);
            console.log('[MORA-UVR] interesesParte:', interesesParte, '| segVidaParte:', segVidaParte, '| segTodoRiesgoParte:', segTodoRiesgoParte);

            var saldoMora = toFixed(
                capitalEnMora +
                interesesParte +
                segVidaParte +
                segTodoRiesgoParte,
                0
            );
            console.log('[MORA-UVR] ✅ saldoMora final:', saldoMora);
        } else {
            var cuotaActual = neededPayments[neededPayments.length - 1].cuota;
            var actualCapital = parseFloat(neededLiq[neededLiq.length - 1].capital);

            console.log('[MORA-PESOS] ── BLOQUE 2: saldoMora PESOS ──');
            console.log('[MORA-PESOS] cuotaActual:', cuotaActual, '| indiceSiguiente:', cuotaActual + 1);
            console.log('[MORA-PESOS] actualCapital:', actualCapital);

            var capitalProyectado = 0;

            const indiceSiguiente = cuotaActual + 1;

            if (
                indiceSiguiente >= 0 &&
                indiceSiguiente < props.proyeccion.length &&
                props.proyeccion[indiceSiguiente]
            ) {
                capitalProyectado = parseFloat(
                    props.proyeccion[indiceSiguiente].capital || 0
                );
                console.log('[MORA-PESOS] proyeccion[indiceSiguiente].capital:', capitalProyectado);
            } else {
                console.log('[MORA-PESOS] ⚠ proyeccion[indiceSiguiente] no existe → capitalProyectado = 0');
            }

            var capitalEnMora = actualCapital - capitalProyectado;
            console.log('[MORA-PESOS] capitalEnMora (antes clamp):', capitalEnMora);

            if (capitalEnMora < 0) {
                capitalEnMora = 0;
            }
            console.log('[MORA-PESOS] capitalEnMora (después clamp):', capitalEnMora);

            var interesesParte =
                parseFloat(finalPeriodLiq?.interesCorrienteCuota || 0) +
                parseFloat(finalPeriodLiq?.interesMoratorioCuota || 0);
            console.log('[MORA-PESOS] interesCorrienteCuota (finalPeriodLiq):', finalPeriodLiq?.interesCorrienteCuota);
            console.log('[MORA-PESOS] interesMoratorioCuota (finalPeriodLiq):', finalPeriodLiq?.interesMoratorioCuota);
            console.log('[MORA-PESOS] interesesParte:', interesesParte);
            console.log('[MORA-PESOS] segVida:', finalPeriodLiq?.segVida, '| segTodoRiesgo:', finalPeriodLiq?.segTodoRiesgo);

            var saldoMora = toFixed(
                capitalEnMora +
                interesesParte +
                parseFloat(finalPeriodLiq?.segVida || 0) +
                parseFloat(finalPeriodLiq?.segTodoRiesgo || 0),
                0
            );
            console.log('[MORA-PESOS] ✅ saldoMora final:', saldoMora);
        }

        if (props.moneda == "uvr") {
            if (neededPayments[0].cuota <= parseFloat(props.plazo)) {
                if (saldoMora > 0) {
                    var textoMora =
                        "Su obligación se encuentra en mora en $" +
                        formatter.format(saldoMora) +
                        " por favor ponerse al dia inmediatamente, su próxima cuota programada es el dia " +
                        ("0" + auxFechaFinPeriodo.getDate()).slice(-2) +
                        "/" +
                        ("0" + (auxFechaFinPeriodo.getMonth() + 1)).slice(-2) +
                        "/" +
                        auxFechaFinPeriodo.getFullYear() +
                        (hasNext
                            ? hasNext
                                ? " por un monto aproximado de $" +
                                formatter.format(toFixed(auxVlrCuota, 0))
                                : ""
                            : "") +
                        "\n" +
                        "IMPORTANTE: por favor comuníquese con nosotros para conocer el valor exacto de su cuota.";
                    var textoPaguese = "PAGUESE INMEDIATAMENTE";
                } else if (saldoMora == 0) {
                    if (actualCapitalUVR == 0) {
                        var textoMora = "Su obligación se encuentra al día.";
                        var textoPaguese = "";
                    } else {
                    var textoMora =
                        "Su obligación está al día, su próxima cuota es del dia " +
                        fechaCompleta +
                        (hasNext
                            ? hasNext
                                ? " por un monto de $" +
                                formatter.format(toFixed(auxVlrCuota, 0))
                                : ""
                            : "");
                    var textoPaguese =
                        "PAGUESE EL: " +
                        ("0" + auxFechaFinPeriodo.getDate()).slice(-2) +
                        "-" +
                        ("0" + (auxFechaFinPeriodo.getMonth() + 1)).slice(-2) +
                        "-" +
                        auxFechaFinPeriodo.getFullYear();
                    }
                } else if (saldoMora == 0) {
                    var textoMora = "Su obligación está al día";
                } else if (
                    props.proyeccion[props.proyeccion.length - 1].fechaFin <
                    neededPayments[0].fechaTx
                ) {
                    var textoMora =
                        "Su obligación se encuentra en mora en $" +
                        formatter.format(saldoMora) +
                        " por favor ponerse al dia inmediatamente por un monto aproximado de $" +
                        formatter.format(toFixed(auxVlrCuota, 0)) +
                        "\n" +
                        "IMPORTANTE: por favor comuníquese con nosotros para conocer el valor exacto de su cuota.";
                }
            } else {
                if (saldoMora > 0) {
                    var textoMora =
                        "Su obligación se encuentra en mora en $" +
                        formatter.format(saldoMora) +
                        " por favor ponerse al dia inmediatamente.";
                    var textoPaguese = "PAGUESE INMEDIATAMENTE";
                } else {
                    var textoMora = "Su obligación está al día";
                    var textoPaguese = "";
                }
            }
            if (window.sessionStorage.getItem("initialPDF") == "true") {
                var auxFecha = props.fechaDesembolso;
                auxFecha.setMonth(auxFecha.getMonth() + 1);
                var textoMora =
                    "Su obligación se encuentra al día, su próxima cuota programada es el dia " +
                    ("0" + auxFecha.getDate()).slice(-2) +
                    "/" +
                    ("0" + (auxFecha.getMonth() + 1)).slice(-2) +
                    "/" +
                    auxFecha.getFullYear() +
                    " por un monto aproximado de $" +
                    formatter.format(toFixed(auxVlrCuota, 0)) +
                    "\n" +
                    "IMPORTANTE: por favor comuníquese con nosotros para conocer el valor exacto de su cuota.";
                setState({ initialPDF: false });
            }
        } else {
            if (neededPayments[0].cuota <= parseFloat(props.plazo)) {
                if (saldoMora > 0) {
                    var textoMora =
                        "Su obligación se encuentra en mora en $" +
                        formatter.format(saldoMora) +
                        " por favor ponerse al dia inmediatamente, su próxima cuota programada es el dia " +
                        ("0" + auxFechaFinPeriodo.getDate()).slice(-2) +
                        "/" +
                        ("0" + (auxFechaFinPeriodo.getMonth() + 1)).slice(-2) +
                        "/" +
                        auxFechaFinPeriodo.getFullYear() +
                        (hasNext
                            ? hasNext
                                ? " por un monto de $" +
                                formatter.format(toFixed(auxVlrCuota, 0))
                                : ""
                            : "");
                    var textoPaguese = "PAGUESE INMEDIATAMENTE";
                } else if (saldoMora == 0) {
                    if (actualCapital == 0) {
                        var textoMora = "Su obligación se encuentra al día.";
                        var textoPaguese = "";
                    } else {
                        var textoMora =
                            "Su obligación está al día, su próxima cuota es del dia " +
                            fechaCompleta +
                            (hasNext
                                ? hasNext
                                    ? " por un monto de $" +
                                    formatter.format(toFixed(auxVlrCuota, 0))
                                    : ""
                                : "");
                        var textoPaguese =
                            "PAGUESE EL: " +
                            ("0" + auxFechaFinPeriodo.getDate()).slice(-2) +
                            "-" +
                            ("0" + (auxFechaFinPeriodo.getMonth() + 1)).slice(-2) +
                            "-" +
                            auxFechaFinPeriodo.getFullYear();
                    }
                } else if (saldoMora < 0) {
                    var textoMora = "Su obligación está al día";
                } else if (
                    props.proyeccion[props.proyeccion.length - 1].fechaFin <
                    neededPayments[0].fechaTx
                ) {
                    var textoMora =
                        "Su obligación se encuentra en mora en $" +
                        formatter.format(saldoMora) +
                        " por favor ponerse al dia inmediatamente por un monto de $" +
                        formatter.format(toFixed(auxVlrCuota, 0));
                }
            } else {
                if (saldoMora > 0) {
                    var textoMora =
                        "Su obligación se encuentra en mora en $" +
                        formatter.format(saldoMora) +
                        " por favor ponerse al dia inmediatamente.";
                    var textoPaguese = "PAGUESE INMEDIATAMENTE";
                } else {
                    var textoMora = "Su obligación está al día";
                    var textoPaguese = "";
                }
            }
            if (window.sessionStorage.getItem("initialPDF") == "true") {
                // Normalizar y validar props.fechaDesembolso antes de usar métodos Date
                var auxFecha = parseFlexibleDate(props.fechaDesembolso);
                if (!auxFecha || isNaN(auxFecha.getTime())) {
                    auxFecha = props.fechaDesembolso ? new Date(props.fechaDesembolso) : null;
                }

                if (auxFecha && !isNaN(auxFecha.getTime())) {
                    auxFecha.setMonth(auxFecha.getMonth() + 1);
                    var textoMora =
                        "Su obligación se encuentra al día, su próxima cuota programada es el dia " +
                        ("0" + auxFecha.getDate()).slice(-2) +
                        "/" +
                        ("0" + (auxFecha.getMonth() + 1)).slice(-2) +
                        "/" +
                        auxFecha.getFullYear() +
                        " por un monto de $" +
                        formatter.format(toFixed(auxVlrCuota, 0));
                } else {
                    // Fallback cuando fecha inválida
                    var textoMora =
                        "Su obligación se encuentra al día, próxima cuota programada (fecha no disponible) por un monto de $" +
                        formatter.format(toFixed(auxVlrCuota, 0));
                }

                setState({ initialPDF: false });
            }
        }

        var liqTables = [];
        var cntNeededPayments = neededPayments[0].id;

        for (let i = 0; i < neededPayments.length; i++) {
            var liqGen = [];

            var auxFecha = new Date(neededPayments[i].fechaTx);
            auxFecha = fixTimeZone(new Date(auxFecha));

            var textoFecha =
                ("0" + auxFecha.getDate()).slice(-2) +
                "-" +
                months[auxFecha.getMonth()] +
                "-" +
                auxFecha.getFullYear();

            // Seguridad: evitar accesos fuera de rango en detalleData y liquidacionesResp
            const detalleEntry =
                props.detalleData && props.detalleData[cntNeededPayments]
                    ? props.detalleData[cntNeededPayments]
                    : null;

            const detalle3_1 =
                detalleEntry && detalleEntry[3] && detalleEntry[3][1]
                    ? detalleEntry[3][1]
                    : "0";

            var auxNuevoCorriente = formatter.format(
                parseFloat(String(detalle3_1).replace(/,/g, "")) || 0
            );

            var auxSegVida = "";
            const liqResp0 =
                props.liquidacionesResp && props.liquidacionesResp[0]
                    ? props.liquidacionesResp[0]
                    : null;

            const detalle0_3 = detalleEntry && detalleEntry[0] && detalleEntry[0][3] != null ? detalleEntry[0][3] : null;

            if (i == 0 && neededPayments[0].id == 0 && detalle0_3 == "0") {
                auxSegVida = formatter.format(liqResp0?.segVida ?? 0);
            } else {
                auxSegVida = detalle0_3 != null ? detalle0_3 : "";
            }

            let auxSegTodoRiesgo = "";
            const detalle0_4 = detalleEntry && detalleEntry[0] && detalleEntry[0][4] != null ? detalleEntry[0][4] : null;
            if (i == 0 && neededPayments[0].id == 0 && detalle0_4 == "0") {
                auxSegTodoRiesgo = formatter.format(liqResp0?.segTodoRiesgo ?? 0);
            } else {
                auxSegTodoRiesgo = detalle0_4 != null ? detalle0_4 : "";
            }

            // Helper: formatear valor de detalleData con separadores de miles
            const fmtD = (v) => formatter.format(parseFloat(String(v).replace(/,/g, "")) || 0);

            if (props.moneda == "uvr") {
                var auxNuevoCorrienteUVR = formatter.format(
                    parseFloat(
                        props.detalleDataUVR[cntNeededPayments][3][1].replace(
                            /,/g,
                            ""
                        )
                    )
                );
                var saldoInicial = [
                    "Saldo Inicial",
                    props.detalleDataUVR[cntNeededPayments][0][0] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][0][0]) +
                    ")",
                    props.detalleDataUVR[cntNeededPayments][0][1] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][0][1]) +
                    ")",
                    props.detalleDataUVR[cntNeededPayments][0][2] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][0][2]) +
                    ")",
                    "$" + auxSegVida,
                    "$" + auxSegTodoRiesgo,
                ];
                var movimientos = [
                    "Movimientos",
                    "",
                    props.detalleDataUVR[cntNeededPayments][1][0] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][1][0]) +
                    ")",
                    props.detalleDataUVR[cntNeededPayments][1][1] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][1][1]) +
                    ")",
                    "$" + fmtD((parseFloat(String(props.detalleData[cntNeededPayments][1][2]).replace(/,/g, "")) || 0) ? props.detalleData[cntNeededPayments][1][2] : props.detalleDataUVR[cntNeededPayments][1][2]),
                    "$" + fmtD((parseFloat(String(props.detalleData[cntNeededPayments][1][3]).replace(/,/g, "")) || 0) ? props.detalleData[cntNeededPayments][1][3] : props.detalleDataUVR[cntNeededPayments][1][3]),
                ];
                var aplicacion = [
                    "Aplicación del pago",
                    props.detalleDataUVR[cntNeededPayments][2][0] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][2][0]) +
                    ")",
                    props.detalleDataUVR[cntNeededPayments][2][1] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][2][1]) +
                    ")",
                    props.detalleDataUVR[cntNeededPayments][2][2] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][2][2]) +
                    ")",
                    "$" + fmtD((parseFloat(String(props.detalleData[cntNeededPayments][2][3]).replace(/,/g, "")) || 0) ? props.detalleData[cntNeededPayments][2][3] : props.detalleDataUVR[cntNeededPayments][2][3]),
                    "$" + fmtD((parseFloat(String(props.detalleData[cntNeededPayments][2][4]).replace(/,/g, "")) || 0) ? props.detalleData[cntNeededPayments][2][4] : props.detalleDataUVR[cntNeededPayments][2][4]),
                ];
                var saldo = [
                    "Nuevo Saldo",
                    props.detalleDataUVR[cntNeededPayments][3][0] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][3][0]) +
                    ")",
                    auxNuevoCorrienteUVR +
                    " UVR" +
                    " " +
                    "($" +
                    auxNuevoCorriente +
                    ")",
                    props.detalleDataUVR[cntNeededPayments][3][2] +
                    " UVR" +
                    " " +
                    "($" +
                    fmtD(props.detalleData[cntNeededPayments][3][2]) +
                    ")",
                    "$" + fmtD((parseFloat(String(props.detalleData[cntNeededPayments][3][3]).replace(/,/g, "")) || 0) ? props.detalleData[cntNeededPayments][3][3] : props.detalleDataUVR[cntNeededPayments][3][3]),
                    "$" + fmtD((parseFloat(String(props.detalleData[cntNeededPayments][3][4]).replace(/,/g, "")) || 0) ? props.detalleData[cntNeededPayments][3][4] : props.detalleDataUVR[cntNeededPayments][3][4]),
                ];
            } else {
                var saldoInicial = [
                    "Saldo Inicial",
                    "$" + fmtD(props.detalleData[cntNeededPayments][0][0]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][0][1]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][0][2]),
                    "$" + auxSegVida,
                    "$" + auxSegTodoRiesgo,
                ];
                var movimientos = [
                    "Movimientos",
                    "",
                    "$" + fmtD(props.detalleData[cntNeededPayments][1][0]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][1][1]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][1][2]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][1][3]),
                ];
                var aplicacion = [
                    "Aplicación del pago",
                    "$" + fmtD(props.detalleData[cntNeededPayments][2][0]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][2][1]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][2][2]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][2][3]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][2][4]),
                ];
                var saldo = [
                    "Nuevo Saldo",
                    "$" + fmtD(props.detalleData[cntNeededPayments][3][0]),
                    "$" + auxNuevoCorriente,
                    "$" + fmtD(props.detalleData[cntNeededPayments][3][2]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][3][3]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][3][4]),
                ];
            }

            if (props.moneda == "uvr") {
                const fmtI = (v) => formatter.format(Math.round(parseFloat(String(v).replace(/,/g, "")) || 0));
                const fmtU = (v) => {
                    const n = parseFloat(String(v).replace(/,/g, "")) || 0;
                    return n.toLocaleString("es-CO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                };
                const rL = finalPeriodLiq;
                const lastRealLiqUVR = neededLiq[neededLiq.length - 1];
                var movimientosRes = [
                    "Movimientos",
                    "",
                    fmtU(lastRealLiqUVR?.interesCorrienteCuotaGenUVR) + " UVR ($" + fmtI(lastRealLiqUVR?.interesCorrienteCuotaGen) + ")",
                    fmtU(lastRealLiqUVR?.interesMoratorioCuotaGenUVR) + " UVR ($" + fmtI(lastRealLiqUVR?.interesMoratorioCuotaGen) + ")",
                    "$" + fmtI(lastRealLiqUVR?.segVida),
                    "$" + fmtI(lastRealLiqUVR?.segTodoRiesgo),
                ];
                var saldoRes = [
                    "Nuevo Saldo",
                    fmtU(rL?.capitalUVR) + " UVR ($" + fmtI(rL?.capital) + ")",
                    fmtU(rL?.interesCorrienteCuotaUVR) + " UVR ($" + fmtI(rL?.interesCorrienteCuota) + ")",
                    fmtU(rL?.interesMoratorioCuotaUVR) + " UVR ($" + fmtI(rL?.interesMoratorioCuota) + ")",
                    "$" + fmtI(rL?.segVida),
                    "$" + fmtI(rL?.segTodoRiesgo),
                ];
            } else {
                const fmtI = (v) => formatter.format(Math.round(parseFloat(String(v).replace(/,/g, "")) || 0));
                const rL = finalPeriodLiq;
                const lastRealLiq = neededLiq[neededLiq.length - 1];
                var movimientosRes = [
                    "Movimientos",
                    "",
                    "$" + fmtI(lastRealLiq?.interesCorrienteCuotaGen),
                    "$" + fmtI(lastRealLiq?.interesMoratorioCuotaGen),
                    "$" + fmtI(lastRealLiq?.segVida),
                    "$" + fmtI(lastRealLiq?.segTodoRiesgo),
                ];
                var saldoRes = [
                    "Nuevo Saldo",
                    "$" + fmtD(props.detalleData[cntNeededPayments][3][0]),
                    "$" + fmtI(rL?.interesCorrienteCuota),
                    "$" + fmtI(rL?.interesMoratorioCuota),
                    "$" + fmtD(props.detalleData[cntNeededPayments][3][3]),
                    "$" + fmtD(props.detalleData[cntNeededPayments][3][4]),
                ];
            }

            if (
                neededPayments.length > 1 &&
                i == neededPayments.length - 1
            ) {
                var auxTable = {
                    style: "tableExample",
                    color: "black",
                    margin: [0, 10, 0, 0],
                    table: {
                        body: [
                            [
                                "",
                                {
                                    text: "Capital",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Interés Corriente",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Interés Moratorio",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Seguro de Vida",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Seguro de Incendio y Todo Riesgo",
                                    style: "textBoldTable",
                                },
                            ],
                            saldoInicial,
                            movimientos,
                            aplicacion,
                            saldo,
                        ],
                    },
                    pageBreak: "after",
                };
            } else {
                var auxTable = {
                    style: "tableExample",
                    color: "black",
                    margin: [0, 10, 0, 0],
                    table: {
                        body: [
                            [
                                "",
                                {
                                    text: "Capital",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Interés Corriente",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Interés Moratorio",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Seguro de Vida",
                                    style: "textBoldTable",
                                },
                                {
                                    text: "Seguro de Incendio y Todo Riesgo",
                                    style: "textBoldTable",
                                },
                            ],
                            saldoInicial,
                            movimientos,
                            aplicacion,
                            saldo,
                        ],
                    },
                };
            }

            var auxTableRes = {
                style: "tableExample",
                color: "black",
                margin: [0, 10, 0, 0],
                table: {
                    body: [
                        [
                            "",
                            { text: "Capital", style: "textBoldTable" },
                            {
                                text: "Interés Corriente",
                                style: "textBoldTable",
                            },
                            {
                                text: "Interés Moratorio",
                                style: "textBoldTable",
                            },
                            {
                                text: "Seguro de Vida",
                                style: "textBoldTable",
                            },
                            {
                                text: "Seguro de Incendio y Todo Riesgo",
                                style: "textBoldTable",
                            },
                        ],
                        movimientosRes,
                        saldoRes,
                    ],
                },
            };
            if (neededPayments[i].vlrTx != 0) {
                if (props.moneda == "uvr") {
                    var text = {
                        text:
                            "Pago " +
                            (i + 1) +
                            ". " +
                            formatter.format(
                                toFixed(neededPayments[i].vlrTxUVR, 2)
                            ) +
                            " UVR " +
                            "($" +
                            formatter.format(toFixed(neededPayments[i].vlrTx, 2)) +
                            ")" +
                            " el " +
                            textoFecha,
                        style: "headerPago",
                        margin: [0, 10, 0, 0],
                    };
                } else {
                    var text = {
                        text:
                            "Pago " +
                            (i + 1) +
                            ". " +
                            formatter.format(toFixed(neededPayments[i].vlrTx, 2)) +
                            " el " +
                            textoFecha,
                        style: "headerPago",
                        margin: [0, 10, 0, 0],
                    };
                }
            } else {
                var text = {
                    text: "",
                    style: "headerPago",
                    margin: [0, 10, 0, 0],
                };
            }

            cntNeededPayments++;

            liqGen.push(text);
            liqGen.push(auxTable);
            liqTables.push(liqGen);
        }
        var auxProps = props;
        var nombre = props.clientesData[0].nombre;
        var direccion = props.clientesData[0].direccion;

        var docDefinition = {
            pageMargins: [40, 280, 40, 200],
            header: function () {
                return [
                    {
                        margin: [0, 0, 0, 10],
                        canvas: [
                            {
                                type: "rect",
                                x: -15,
                                y: -15,
                                w: 610,
                                h: 76,
                                color: "#e92128",
                            },
                        ],
                    },
                    {
                        margin: [0, 0, 0, 10],
                        canvas: [
                            {
                                type: "rect",
                                x: -15,
                                y: -20,
                                w: 610,
                                h: 8,
                                color: "#B9B9B9",
                            },
                        ],
                    },
                    {
                        text: "INMOBILIARIA",
                        style: "title1",
                        absolutePosition: { x: 305, y: 5 },
                    },
                    {
                        text: "MOBILIA",
                        style: "title2",
                        absolutePosition: { x: 305, y: 27 },
                    },
                    {
                        width: 100,
                        image: logo,
                        alignment: "center",
                        absolutePosition: { y: 6, x: -110 },
                    },
                    {
                        margin: [40, 0, 0, 0],
                        lineHeight: 1.3,
                        text: "ESTADO DE CUENTA",
                        style: "textBold",
                    },
                    {
                        margin: [40, 0, 0, 5],
                        canvas: [
                            {
                                type: "line",
                                x1: 0,
                                y1: 0,
                                x2: 515,
                                y2: 0,
                                lineWidth: 3,
                                lineColor: "red",
                            },
                        ],
                    },
                    {
                        margin: [40, 0, 0, 0],
                        lineHeight: 2.5,
                        text: "PERIODO ENTRE " + fechasPeriodo,
                        style: "redText",
                    },
                    {
                        margin: [40, 0, 0, 0],
                        lineHeight: 2,
                        text: "OBLIGACION HIPOTECARIA NUMERO:",
                        style: "textBold",
                    },
                    {
                        absolutePosition: { y: 124, x: 405 },
                        canvas: [
                            {
                                type: "rect",
                                x: 0,
                                y: 0,
                                w: 150,
                                h: 30,
                                color: "#DCDDDF",
                            },
                        ],
                    },
                    {
                        lineHeight: 2,
                        text: auxProps.financialCode
                            ? auxProps.financialCode
                            : auxProps.id,
                        style: "textBold",
                        alignment: "right ",
                        absolutePosition: { y: 134, x: 460 },
                    },
                    {
                        margin: [40, 0, 0, 5],
                        canvas: [
                            {
                                type: "line",
                                x1: 0,
                                y1: 0,
                                x2: 515,
                                y2: 0,
                                lineWidth: 3,
                                lineColor: "red",
                            },
                        ],
                    },
                    {
                        margin: [40, 10, 40, 0],

                        table: {
                            body: [
                                [
                                    {
                                        fillColor: "#DCDDDF",
                                        border: [false, false, false, false],
                                        columns: [
                                            {
                                                width: 250,
                                                stack: [
                                                    {
                                                        lineHeight: 1.5,
                                                        text: "APRECIADO CLIENTE",
                                                        style: "text",
                                                    },
                                                    {
                                                        lineHeight: 1.5,
                                                        text: auxProps.clientesData[0].nombre,
                                                        style: "textBold",
                                                    },
                                                    {
                                                        lineHeight: 1.5,
                                                        text: auxProps.clientesData[0].direccion,
                                                        style: "text",
                                                    },
                                                ],
                                            },
                                            {
                                                width: "auto",
                                                columns: [
                                                    {
                                                        stack: [
                                                            {
                                                                lineHeight: 1,
                                                                text: "Valor del crédito:",
                                                                style: "textBold",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text: "Fecha de desembolso:",
                                                                style: "textBold",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text: "Tasa de interés:",
                                                                style: "textBold",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text: "Plazo:",
                                                                style: "textBold",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text: "Sistema de Amortización:",
                                                                style: "textBold",
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        stack: [
                                                            {
                                                                lineHeight: 1,
                                                                text: "$" + auxProps.vlrInicial,
                                                                style: "text",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text: fechaDesembolsoReal,
                                                                style: "text",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text:
                                                                    auxProps.interes + " % " + "E.A.",
                                                                style: "text",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text: auxProps.plazo + " meses",
                                                                style: "text",
                                                            },
                                                            {
                                                                lineHeight: 1,
                                                                text:
                                                                    auxProps.amortizacion +
                                                                    " en " +
                                                                    auxProps.moneda,
                                                                style: "text",
                                                            },
                                                        ],
                                                    },
                                                ],
                                                columnGap: 10,
                                            },
                                        ],
                                        columnGap: 30,
                                    },
                                ],
                            ],
                        },
                    },
                    {
                        margin: [40, 10, 40, 0],
                        table: {
                            widths: ["*"],
                            body: [
                                [
                                    {
                                        fontSize: 10,
                                        fillColor: "#DCDDDF",
                                        border: [false, false, false, false],
                                        alignment: "center",
                                        margin: [0, 7, 0, 7],
                                        columns: [
                                            {
                                                text: "PAGOS RECIBIDOS EN ESTE PERIODO",
                                                bold: true,
                                            },
                                        ],
                                    },
                                ],
                            ],
                        },
                    },
                ];
            },
            footer: function () {
                return [
                    {
                        absolutePosition: { y: 60, x: 0 },
                        canvas: [
                            {
                                type: "rect",
                                x: 0,
                                y: 0,
                                w: 700,
                                h: 78,
                                color: "#DCDDDF",
                            },
                        ],
                    },
                    {
                        lineHeight: 2,
                        text: "FORMA DE PAGO",
                        style: "textBold",
                        alignment: "center",
                        absolutePosition: { x: 0, y: 72 },
                    },
                    {
                        absolutePosition: { x: 20, y: 93 },
                        margin: [40, 0, 0, 40],
                        canvas: [
                            {
                                type: "line",
                                x1: 0,
                                y1: 0,
                                x2: 515,
                                y2: 0,
                                lineWidth: 3,
                                lineColor: "red",
                            },
                        ],
                    },
                    {
                        absolutePosition: { y: 102, x: 0 },
                        lineHeight: 1.2,
                        text: "Su pago lo puede efectuar en el Banco Caja Social Cuenta convenio No. 11542 \na nombre de Inmobiliaria Mobilia S.A. En cualquier ciudad del país",
                        style: "textBold",
                        alignment: "center",
                    },
                    {
                        width: 600,
                        image: footer,
                        alignment: "center",
                        absolutePosition: { y: 137, x: 0 },
                    },
                ];
            },
            content: [
                liqTables,
                {
                    margin: [0, 10, 0, 0],
                    text: "Resultado del periodo:",
                    style: "text",
                },
                auxTableRes,
                {
                    margin: [0, 15, 0, 0],
                    table: {
                        widths: ["*"],
                        body: [
                            [
                                {
                                    fontSize: 10,
                                    fillColor: "#DCDDDF",
                                    border: [false, false, false, false],
                                    alignment: "center",
                                    margin: [0, 7, 0, 5],
                                    columns: [
                                        {
                                            lineHeight: 1.5,
                                            text: textoMora,
                                            bold: false,
                                        },
                                    ],
                                },
                            ],
                        ],
                    },
                },
            ],
            styles: {
                subtitle: {
                    fontSize: 10,
                    bold: true,
                },
                text: {
                    fontSize: 10,
                    bold: false,
                },
                textBoldTable: {
                    fontSize: 9,
                    bold: true,
                },
                headerPago: {
                    fontSize: 10,
                    bold: false,
                },
                textBold: {
                    fontSize: 10,
                    bold: true,
                },
                tableHeader: {
                    fontSize: 8,
                    bold: true,
                },
                tableHeaderColor: {
                    fontSize: 8,
                    bold: true,
                    color: "white",
                    fillColor: "#e92128",
                },
                redText: {
                    fontSize: 10,
                    bold: true,
                    color: "#e92128",
                },
                tableExample: {
                    fontSize: 8,
                    color: "black",
                },
                tableExample2: {
                    fontSize: 9,
                    color: "black",
                },

                title1: {
                    fontSize: 15,
                    color: "white",
                },
                title2: {
                    fontSize: 20,
                    bold: true,
                    color: "white",
                },
            },
        };

        const fechaFinPeriodoDescarga =
            ("0" + auxFin.getDate()).slice(-2) +
            "-" +
            ("0" + (auxFin.getMonth() + 1)).slice(-2) +
            "-" +
            auxFin.getFullYear();

        pdfMake.createPdf(docDefinition).download(`Extracto_${props.id}_${fechaFinPeriodoDescarga}.pdf`);
        if (window.sessionStorage.getItem("initialPDF") == "true") {

            delPago();
            window.sessionStorage.setItem("initialPDF", "false");
        }
    } else {
        toast.error(
            "No existen valores UVR para el periodo seleccionado"
        );
    }
};

export const generateInitialPDF = (props, {
    formatter,
    toFixed,
    fixTimeZone,
    toast,
    logo,
    footer,
    apiMethods,
    axios,
    pdfMake
}) => {// Validar que exista fecha de desembolso
    if (!props.fechaDesembolso) {
        toast.error("No se encontró la fecha de desembolso");
        return;
    }

    let actUsrToken = window.sessionStorage.getItem("localToken");
    const periodo = 0; // Siempre período 0 para el PDF inicial

    // ============================================
    // PASO 1: Preparar fechas para el PDF inicial
    // ============================================
    const months = [
        "ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
        "JUL", "AGO", "SEP", "OCT", "NOV", "DIC",
    ];

    // Parsear fecha de desembolso
    let fechaDesembolso = props.fechaDesembolso;
    if (typeof fechaDesembolso === "string" || typeof fechaDesembolso === "number") {
        fechaDesembolso = new Date(fechaDesembolso);
    }

    if (!fechaDesembolso || isNaN(fechaDesembolso.getTime())) {
        toast.error("Fecha de desembolso inválida");
        return;
    }

    // Calcular fecha para consulta UVR (mes siguiente al desembolso)
    const fechaParaUVR = new Date(fechaDesembolso);
    fechaParaUVR.setMonth(fechaParaUVR.getMonth() + 1);

    const auxDia = ("0" + fechaParaUVR.getDate()).slice(-2);
    let auxMes = fechaParaUVR.getMonth() + 1;
    const auxAnio = fechaParaUVR.getFullYear();

    if (auxMes < 10) {
        auxMes = "0" + auxMes;
    }

    const parsedDate = auxDia + "-" + auxMes + "-" + auxAnio;

    // Calcular texto del período
    let auxIni = new Date(fechaDesembolso);
    let auxFin = fixTimeZone(new Date(props.proyeccion[0].fechaFin));

    const fechasPeriodo =
        ("0" + auxIni.getUTCDate()).slice(-2) +
        " " +
        months[auxIni.getUTCMonth()] +
        " " +
        auxIni.getUTCFullYear() +
        " al " +
        ("0" + auxFin.getUTCDate()).slice(-2) +
        " " +
        months[auxFin.getUTCMonth()] +
        " " +
        auxFin.getUTCFullYear();

    // ============================================
    // PASO 2: Consultar UVR
    // ============================================
    axios
        .get(apiMethods.GET_UVR_FECHA + parsedDate, {
            headers: { Authorization: actUsrToken },
        })
        .then((response) => {
            if (!response.data.uvr && props.moneda === "uvr") {
                toast.error("No existen valores UVR para la fecha inicial");
                return;
            }

            const vlrUVRInit = response.data.uvr?.[0]?.valor
                ? parseFloat(response.data.uvr[0].valor)
                : 1;

            // ============================================
            // PASO 3: Calcular próxima cuota
            // ============================================
            const fechaProxCuota = new Date(fechaDesembolso);
            fechaProxCuota.setMonth(fechaProxCuota.getMonth() + 1);

            const parseFlexibleNumber = (v) => {
                if (v === null || v === undefined || v === "") return 0;
                if (typeof v === "number") return v;
                let s = String(v).replace(/\s|\$|COP|USD|UVR/gi, "");
                const hasComma = s.includes(",");
                const hasDot = s.includes(".");
                if (hasComma && hasDot) {
                    if (s.lastIndexOf(",") > s.lastIndexOf(".")) {
                        s = s.replace(/\./g, "").replace(",", ".");
                    } else {
                        s = s.replace(/,/g, "");
                    }
                } else if (hasComma) {
                    const parts = s.split(",");
                    if (parts[1] && parts[1].length <= 2) {
                        s = parts[0].replace(/,/g, "") + "." + parts[1];
                    } else {
                        s = s.replace(/,/g, "");
                    }
                } else if (hasDot) {
                    const parts = s.split(".");
                    if (parts[1] && parts[1].length > 2) {
                        s = s.replace(/\./g, "");
                    }
                }
                const n = Number(s);
                return Number.isFinite(n) ? n : 0;
            };

            let auxVlrCuota = 0;
            if (props.proyeccion[0]) {
                if (props.moneda === "uvr") {
                    auxVlrCuota =
                        parseFlexibleNumber(props.proyeccion[0].vlrCuotaUVR) * vlrUVRInit;
                } else {
                    auxVlrCuota = parseFlexibleNumber(props.proyeccion[0].vlrCuota);
                }
                auxVlrCuota += parseFlexibleNumber(props.proyeccion[0].segVida);
                auxVlrCuota += parseFlexibleNumber(props.proyeccion[0].segTodoRiesgo);
            }

            // ============================================
            // PASO 4: Formatear fecha de desembolso
            // ============================================
            const fechaDesembolsoReal =
                new Intl.DateTimeFormat("en", { day: "2-digit", timeZone: "UTC" }).format(fechaDesembolso) +
                " de " +
                new Intl.DateTimeFormat("es", { month: "long", timeZone: "UTC" }).format(fechaDesembolso) +
                " " +
                new Intl.DateTimeFormat("en", { year: "numeric", timeZone: "UTC" }).format(fechaDesembolso);

            // ============================================
            // PASO 5: Generar texto de mora
            // ============================================
            const textoMora =
                "Su obligación se encuentra al día, su próxima cuota programada es el día " +
                ("0" + fechaProxCuota.getDate()).slice(-2) + "/" +
                ("0" + (fechaProxCuota.getMonth() + 1)).slice(-2) + "/" +
                fechaProxCuota.getFullYear() +
                " por un monto de $" + formatter.format(toFixed(auxVlrCuota, 0));

            const textoPaguese =
                "PAGUESE EL: " +
                ("0" + fechaProxCuota.getDate()).slice(-2) + "-" +
                ("0" + (fechaProxCuota.getMonth() + 1)).slice(-2) + "-" +
                fechaProxCuota.getFullYear();

            // ============================================
            // PASO 6: Crear contenido del PDF
            // ============================================
            const saldoInicial = props.moneda === "uvr"
                ? [
                    "Saldo Inicial",
                    formatter.format(toFixed(props.proyeccion[0].vlrCapitalUVR, 2)) +
                    " UVR ($" +
                    formatter.format(toFixed(props.proyeccion[0].capital, 0)) +
                    ")",
                    "0 UVR ($0)",
                    "0 UVR ($0)",
                    "$0",
                    "$0",
                ]
                : [
                    "Saldo Inicial",
                    "$" + formatter.format(toFixed(props.proyeccion[0].capital, 0)),
                    "$0",
                    "$0",
                    "$0",
                    "$0",
                ];

            const movimientos = [
                "Movimientos",
                "",
                "",
                "",
                "",
                "",
            ];

            const aplicacion = [
                "Aplicación del pago",
                "",
                "",
                "",
                "",
                "",
            ];

            const nuevoSaldo = saldoInicial.slice(); // Copia del saldo inicial
            nuevoSaldo[0] = "Nuevo Saldo";

            const liqTables = [
                [
                    {
                        style: "tableExample",
                        color: "black",
                        margin: [0, -20, 0, 0],
                        table: {
                            body: [
                                [
                                    "",
                                    { text: "Capital", style: "textBoldTable" },
                                    { text: "Interés Corriente", style: "textBoldTable" },
                                    { text: "Interés Moratorio", style: "textBoldTable" },
                                    { text: "Seguro de Vida", style: "textBoldTable" },
                                    { text: "Seguro de Incendio y Todo Riesgo", style: "textBoldTable" },
                                ],
                                saldoInicial,
                                movimientos,
                                aplicacion,
                                nuevoSaldo,
                            ],
                        },
                    },
                ],
            ];

            // ============================================
            // PASO 7: Generar PDF
            // ============================================
            const docDefinition = {
                pageMargins: [40, 280, 40, 200],
                header: function () {
                    return [
                        {
                            margin: [0, 0, 0, 10],
                            canvas: [
                                {
                                    type: "rect",
                                    x: -15,
                                    y: -15,
                                    w: 610,
                                    h: 76,
                                    color: "#e92128",
                                },
                            ],
                        },
                        {
                            margin: [0, 0, 0, 10],
                            canvas: [
                                {
                                    type: "rect",
                                    x: -15,
                                    y: -20,
                                    w: 610,
                                    h: 8,
                                    color: "#B9B9B9",
                                },
                            ],
                        },
                        {
                            text: "INMOBILIARIA",
                            style: "title1",
                            absolutePosition: { x: 305, y: 5 },
                        },
                        {
                            text: "MOBILIA",
                            style: "title2",
                            absolutePosition: { x: 305, y: 27 },
                        },
                        {
                            width: 100,
                            image: logo,
                            alignment: "center",
                            absolutePosition: { y: 6, x: -110 },
                        },
                        {
                            margin: [40, 0, 0, 0],
                            lineHeight: 1.3,
                            text: "ESTADO DE CUENTA INICIAL",
                            style: "textBold",
                        },
                        {
                            margin: [40, 0, 0, 5],
                            canvas: [
                                {
                                    type: "line",
                                    x1: 0,
                                    y1: 0,
                                    x2: 515,
                                    y2: 0,
                                    lineWidth: 3,
                                    lineColor: "red",
                                },
                            ],
                        },
                        {
                            margin: [40, 0, 0, 0],
                            lineHeight: 2.5,
                            text: "PERIODO ENTRE " + fechasPeriodo,
                            style: "redText",
                        },
                        {
                            margin: [40, 0, 0, 0],
                            lineHeight: 2,
                            text: "OBLIGACION HIPOTECARIA NUMERO:",
                            style: "textBold",
                        },
                        {
                            absolutePosition: { y: 124, x: 405 },
                            canvas: [
                                {
                                    type: "rect",
                                    x: 0,
                                    y: 0,
                                    w: 150,
                                    h: 30,
                                    color: "#DCDDDF",
                                },
                            ],
                        },
                        {
                            lineHeight: 2,
                            text: props.financialCode ? props.financialCode : props.id,
                            style: "textBold",
                            alignment: "right ",
                            absolutePosition: { y: 134, x: 460 },
                        },
                        {
                            margin: [40, 0, 0, 5],
                            canvas: [
                                {
                                    type: "line",
                                    x1: 0,
                                    y1: 0,
                                    x2: 515,
                                    y2: 0,
                                    lineWidth: 3,
                                    lineColor: "red",
                                },
                            ],
                        },
                        {
                            margin: [40, 10, 40, 0],
                            table: {
                                body: [
                                    [
                                        {
                                            fillColor: "#DCDDDF",
                                            border: [false, false, false, false],
                                            columns: [
                                                {
                                                    width: 250,
                                                    stack: [
                                                        {
                                                            lineHeight: 1.5,
                                                            text: "APRECIADO CLIENTE",
                                                            style: "text",
                                                        },
                                                        {
                                                            lineHeight: 1.5,
                                                            text: props.clientesData[0].nombre,
                                                            style: "textBold",
                                                        },
                                                        {
                                                            lineHeight: 1.5,
                                                            text: props.clientesData[0].direccion,
                                                            style: "text",
                                                        },
                                                    ],
                                                },
                                                {
                                                    width: "auto",
                                                    columns: [
                                                        {
                                                            stack: [
                                                                {
                                                                    lineHeight: 1,
                                                                    text: "Valor del crédito:",
                                                                    style: "textBold",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: "Fecha de desembolso:",
                                                                    style: "textBold",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: "Tasa de interés:",
                                                                    style: "textBold",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: "Plazo:",
                                                                    style: "textBold",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: "Sistema de Amortización:",
                                                                    style: "textBold",
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            stack: [
                                                                {
                                                                    lineHeight: 1,
                                                                    text: "$" + props.vlrInicial,
                                                                    style: "text",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: fechaDesembolsoReal,
                                                                    style: "text",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: props.interes + " % E.A.",
                                                                    style: "text",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: props.plazo + " meses",
                                                                    style: "text",
                                                                },
                                                                {
                                                                    lineHeight: 1,
                                                                    text: props.amortizacion + " en " + props.moneda,
                                                                    style: "text",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                    columnGap: 10,
                                                },
                                            ],
                                            columnGap: 30,
                                        },
                                    ],
                                ],
                            },
                        },
                    ];
                },
                footer: function () {
                    return [
                        {
                            absolutePosition: { y: 60, x: 0 },
                            canvas: [
                                {
                                    type: "rect",
                                    x: 0,
                                    y: 0,
                                    w: 700,
                                    h: 78,
                                    color: "#DCDDDF",
                                },
                            ],
                        },
                        {
                            lineHeight: 2,
                            text: "FORMA DE PAGO",
                            style: "textBold",
                            alignment: "center",
                            absolutePosition: { x: 0, y: 72 },
                        },
                        {
                            absolutePosition: { x: 20, y: 93 },
                            margin: [40, 0, 0, 40],
                            canvas: [
                                {
                                    type: "line",
                                    x1: 0,
                                    y1: 0,
                                    x2: 515,
                                    y2: 0,
                                    lineWidth: 3,
                                    lineColor: "red",
                                },
                            ],
                        },
                        {
                            absolutePosition: { y: 102, x: 0 },
                            lineHeight: 1.2,
                            text:
                                "Su pago lo puede efectuar en el Banco Caja Social Cuenta convenio No. 11542 \na nombre de Inmobiliaria Mobilia S.A. En cualquier ciudad del país",
                            style: "textBold",
                            alignment: "center",
                        },
                        {
                            width: 600,
                            image: footer,
                            alignment: "center",
                            absolutePosition: { y: 137, x: 0 },
                        },
                    ];
                },
                content: [
                    liqTables,
                    {
                        margin: [0, 15, 0, 0],
                        table: {
                            widths: ["*"],
                            body: [
                                [
                                    {
                                        fontSize: 10,
                                        fillColor: "#DCDDDF",
                                        border: [false, false, false, false],
                                        alignment: "center",
                                        margin: [0, 7, 0, 5],
                                        columns: [
                                            {
                                                lineHeight: 1.5,
                                                text: textoMora,
                                                bold: false,
                                            },
                                        ],
                                    },
                                ],
                            ],
                        },
                    },
                ],
                styles: {
                    subtitle: {
                        fontSize: 10,
                        bold: true,
                    },
                    text: {
                        fontSize: 10,
                        bold: false,
                    },
                    textBoldTable: {
                        fontSize: 9,
                        bold: true,
                    },
                    headerPago: {
                        fontSize: 10,
                        bold: false,
                    },
                    textBold: {
                        fontSize: 10,
                        bold: true,
                    },
                    tableHeader: {
                        fontSize: 8,
                        bold: true,
                    },
                    tableHeaderColor: {
                        fontSize: 8,
                        bold: true,
                        color: "white",
                        fillColor: "#e92128",
                    },
                    redText: {
                        fontSize: 10,
                        bold: true,
                        color: "#e92128",
                    },
                    tableExample: {
                        fontSize: 8,
                        color: "black",
                    },
                    tableExample2: {
                        fontSize: 9,
                        color: "black",
                    },
                    title1: {
                        fontSize: 15,
                        color: "white",
                    },
                    title2: {
                        fontSize: 20,
                        bold: true,
                        color: "white",
                    },
                },
            };

            pdfMake.createPdf(docDefinition).download("estado_cuenta_inicial.pdf");

            toast.success("Estado de cuenta inicial generado correctamente");
        })
        .catch((error) => {
            console.error("Error al generar PDF inicial:", error);
            toast.error("Error al generar el PDF inicial");
        });
};